import React from 'react'
import { Button } from '@material-ui/core'
import PopUpSkapaTidsrapport from '../../../../../SkapaTidsrapport/PopUpSkapaTidsrapport';
import IntlMessages from 'util/IntlMessages';

export default function RegisterTimeComponent() {
	const [open, setOpen] = React.useState()
	return (
		<>
		<div className='w-100 h-100 d-flex align-items-center justify-content-center'>
		<Button variant="contained" color='primary' size='large' onClick={()=>setOpen(true)}>
		<IntlMessages id="Time.Register"/>
		</Button>
		</div>
		<PopUpSkapaTidsrapport 
			open={open}
			handleClose={()=>setOpen(false)}
		/>
		</>
	)
}
